import React, { useEffect, useState } from "react";
import { ShieldAlert, Paperclip } from "lucide-react";
import { reportsApi, formatDate } from "../../lib/api";

const STATUS = {
  under_review: { label: "Under review", cls: "bg-amber-100 text-amber-700" },
  action_taken: { label: "Action taken", cls: "bg-green-100 text-green-700" },
  reviewed: { label: "Reviewed", cls: "bg-surface-200 text-ink-soft" },
};

// Lets a customer track the status/outcome of misconduct reports they filed.
export default function MyReports() {
  const [reports, setReports] = useState(null);

  useEffect(() => { reportsApi.mine().then((d) => setReports(d.reports || [])).catch(() => setReports([])); }, []);

  if (reports === null) return <p className="text-sm text-ink-muted">Loading…</p>;
  if (reports.length === 0) return <p className="text-sm text-ink-muted" data-testid="my-reports-empty">You haven't filed any reports. You can report a partner from a ride, order or booking.</p>;

  return (
    <div className="space-y-3" data-testid="my-reports">
      {reports.map((r) => {
        const s = STATUS[r.status] || STATUS.reviewed;
        return (
          <div key={r.report_id} className="rounded-2xl border border-surface-200 bg-white p-4" data-testid={`my-report-${r.report_id}`}>
            <div className="flex flex-wrap items-center justify-between gap-2">
              <p className="flex items-center gap-2 text-sm font-semibold text-ink">
                <ShieldAlert className="h-4 w-4 text-red-600" />
                <span className="capitalize">{(r.category || "").replace(/_/g, " ")}</span>
                <span className="text-ink-muted">· {r.target_label}</span>
                {r.has_photos && <Paperclip className="h-3.5 w-3.5 text-ink-muted" />}
              </p>
              <span className={`rounded-full px-2.5 py-0.5 text-xs font-semibold ${s.cls}`} data-testid={`my-report-status-${r.report_id}`}>{s.label}</span>
            </div>
            {r.description && <p className="mt-2 text-sm text-ink-soft">“{r.description}”</p>}
            <p className="mt-1 text-xs text-ink-muted">{r.outcome} · filed {formatDate(r.created_at, { timeStyle: undefined })}</p>
          </div>
        );
      })}
    </div>
  );
}
